import { EGraphType } from '../../../repositories/valuation-b2b/v1/get-graph-data';
import { TIndexTab } from '../../../types/redux';

export function getGraphType(indexTab: TIndexTab) {
  switch (indexTab) {
    case 0:
      return EGraphType.DealCountPrimary;
    case 1:
      return EGraphType.DealPercentPrimary;
    case 2:
      return EGraphType.PriceSqmSecondary;
  }
}
